import { AvvirEvent } from "type_aliases";
import { ApiMasterFormatWithUniformat } from "avvir";

export type MasterformatWithUniformatLoadedEvent = AvvirEvent<typeof MASTERFORMAT_WITH_UNIFORMAT_LOADED, ApiMasterFormatWithUniformat[]>;

const masterformatWithUniformatLoaded = (masterFormatWithUniformats: ApiMasterFormatWithUniformat[]): MasterformatWithUniformatLoadedEvent => ({
  type: MASTERFORMAT_WITH_UNIFORMAT_LOADED,
  payload: masterFormatWithUniformats,
});

export const MASTERFORMAT_WITH_UNIFORMAT_LOADED = "masterformat_with_uniformat_loaded";

export default masterformatWithUniformatLoaded;